import { CompassCanvas, getDirectionName } from "@/global/utils/display-utils"
import { useEffect, useState } from "react"
import "./index.less"
import { queryInfluxCurrentData, queryInfluxDataList } from "@/api/influx/influx"
import { TimeValue } from "@/global/interface/time-value"
import { Skeleton, Spin, message } from "antd"

interface IProps {
    waterLevel: number
}

export default function WaterFirstPanel(props: IProps) {

    return (
        <div className="water-first-panel">
            <div className="water-item">
                <div className="first-row">目前</div>
                <div className="second-row">
                    <div className="data">{props.waterLevel || '0'}</div>
                    <div className="unit">毫米</div>
                </div>
            </div>
        </div>
    )
}